import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  cdtAttributesInterface,
  CustomDataTypesSliceState,
} from "./customDataTypes-interface";
import {
  fetchCustomDataTypes,
  fetchCustomDataTypesByApplication,
  fetchCustomDataTypeById,
  fetchDataTypes,
} from "./customDataTypes-async-calls";

const initialState: CustomDataTypesSliceState = {
  customDataTypes: [],
  selectedCustomDataType: null,
  selectedCustomDataTypeAttr: [],
  dataTypes: [],
  isFetching: false,
};

const customDataTypesSlice = createSlice({
  name: "customDataTypes",
  initialState,
  reducers: {
    setSelectedCustomDataTypeAttributes: (
      state,
      action: PayloadAction<cdtAttributesInterface[]>
    ) => {
      console.log("called");
      state.selectedCustomDataTypeAttr = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomDataTypesByApplication.pending, (state) => {
        state.customDataTypes = [];
        state.isFetching = true;
      })
      .addCase(fetchCustomDataTypesByApplication.fulfilled, (state, action) => {
        state.customDataTypes = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchCustomDataTypesByApplication.rejected, (state) => {
        state.customDataTypes = [];
        state.isFetching = false;
      })
      .addCase(fetchCustomDataTypes.pending, (state) => {
        state.customDataTypes = [];
        state.isFetching = true;
      })
      .addCase(fetchCustomDataTypes.fulfilled, (state, action) => {
        state.customDataTypes = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchCustomDataTypes.rejected, (state) => {
        state.customDataTypes = [];
        state.isFetching = false;
      })
      .addCase(fetchCustomDataTypeById.pending, (state) => {
        state.selectedCustomDataType = null;
        state.selectedCustomDataTypeAttr = [];
        state.isFetching = true;
      })
      .addCase(fetchCustomDataTypeById.fulfilled, (state, action) => {
        state.selectedCustomDataType = action.payload;
        state.selectedCustomDataTypeAttr = action.payload.cdtAttributes;
        state.isFetching = false;
      })
      .addCase(fetchCustomDataTypeById.rejected, (state) => {
        state.selectedCustomDataType = null;
        state.selectedCustomDataTypeAttr = [];
        state.isFetching = false;
      })
      .addCase(fetchDataTypes.pending, (state) => {
        state.dataTypes = [];
        state.isFetching = true;
      })
      .addCase(fetchDataTypes.fulfilled, (state, action) => {
        state.dataTypes = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchDataTypes.rejected, (state) => {
        state.dataTypes = [];
        state.isFetching = false;
      });
  },
});

export const { setSelectedCustomDataTypeAttributes } =
  customDataTypesSlice.actions;

export default customDataTypesSlice.reducer;
